import React from "react"
import { FiRefreshCw } from "react-icons/fi"
import { RiEraserFill } from "react-icons/ri"
import { AiOutlineMenuUnfold } from "react-icons/ai"

interface IProps {
  setSearchString: React.Dispatch<React.SetStateAction<string>>
  searchString: string
  setShowCreate: React.Dispatch<React.SetStateAction<boolean>>
  isLoading: boolean
  setNavBar: React.Dispatch<React.SetStateAction<boolean>>
  refetch: any
}

const Header: React.FC<IProps> = ({
  setSearchString,
  searchString,
  setShowCreate,
  isLoading,
  refetch,
  setNavBar,
}) => {
  return (
    <header className="flex items-center justify-between w-full px-2 py-2 m-1 border-b-2 border-red-300 border-solid ">
      <div className="flex flex-row items-center justify-center space-x-2">
        <div
          className=" hover:cursor-pointer hover:text-slate-300"
          onClick={() => {
            setNavBar((c) => !c)
          }}
        >
          <AiOutlineMenuUnfold className="text-3xl " />
        </div>

        <div className="flex border rounded-sm align-center border-slate-300">
          <input
            className="m-1 text-xs outline-none  md:text-sm bg-inherit border-slate-500"
            type="text"
            placeholder="Search any.."
            id="searchInput"
            name="searchInput"
            value={searchString}
            onChange={(e) => {
              setSearchString(e.target.value)
            }}
          />
          <button
            onClick={() => {
              setSearchString("")
            }}
            className="grid px-2 ml-1 border-l-2 place-items-center hover:cursor-pointer active:text-slate-500 bg-slate-100 text-slate-600"
          >
            <RiEraserFill />
          </button>
        </div>
      </div>
      <div className="flex items-center justify-center space-x-3">
        <button
          className="border-[1px] bg-red-400 text-xs md:text-sm rounded-sm px-2 py-1 hover:bg-red-500"
          onClick={() => {
            setShowCreate(true)
          }}
        >
          Create
        </button>
        <p
          className="flex items-center justify-center w-10 h-10 border-2 border-red-400 rounded-full cursor-pointer focus:border-8 hover:border-red-500"
          onClick={() => {
            refetch()
          }}
        >
          <span className={`${isLoading ? "animate-spin" : ""}`}>
            <FiRefreshCw />
          </span>
        </p>
      </div>
    </header>
  )
}

export default Header
